var map = {
	"./angna.png": "0934",
	"./btn-account-balance-bm.png": "32a9",
	"./btn-account-balance-en.png": "6974",
	"./btn-account-balance-th.png": "cd83",
	"./btn-green-bm.png": "91f5",
	"./btn-green-en.png": "41f9",
	"./btn-green-th.png": "5bc5",
	"./btn-personal-info-bm.png": "5ae2",
	"./btn-personal-info-en.png": "0e20",
	"./btn-personal-info-th.png": "fd48",
	"./bubble.png": "c5d3",
	"./dashboard-en copy.png": "482f",
	"./dashboard-en.png": "c76c",
	"./home-bg-bm.png": "c5c4",
	"./home-bg-en.png": "0ff3",
	"./home-bg-th.png": "f88a",
	"./sara.png": "4a49",
	"./thampi-hand.png": "1350"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1450";